import React from "react";

const SurfLoader: React.FC<{ style?: any }> = ({style}) => {
    return <object style={style} height={200} type={"image/svg+xml"} data={"/static/images/loader/surfLoader.svg"}/>
}
export default SurfLoader;